import type { ReactNode } from 'react';
import { toast } from 'sonner';

interface ToastOptions {
  contentSlot?: ReactNode;
  description?: string;
  title: string;
}

export const toaster = {
  error: ({ description, title }: ToastOptions) => {
    toast.error(title, { description });
  },
  success: ({ contentSlot, description, title }: ToastOptions) => {
    toast.success(contentSlot ?? title, { description });
  },
};
